import { useEffect, useMemo, useState } from 'react';
import { useFormContext } from 'react-hook-form';

import { useAuth } from '@restworld/feature-authentication';
import { cn, useWizard } from '@restworld/utils-common';

import { WizardStepsProps } from '../worker-application-wizard.types';
import { FormInputs } from './form-inputs';
import { Header } from './form-header';
import { useHeadLines } from '../worker-application-wizard.constants';
import { useWorkerApplicationCxt } from '../worker-application-wizard.context';

export const WizardStep = ({
  mainTitle,
  formHeaderTitle,
  completedPercentage,
  info,
  headerKey,
  isConfirmation,
  confirmationTitle,
  canBeSkipped,
  id,
  ...rest
}: WizardStepsProps) => {
  const [entryTime, setEntryTime] = useState<number>(Date.now());
  const { activeStep } = useWizard();
  const headLines = useHeadLines();
  const { mainTitleCp, formHeaderTitleCp } = useMemo(() => {
    const index = headLines.findIndex((v) => v.key === headerKey);
    return {
      mainTitleCp: headLines[index]?.mainTitle ?? mainTitle,
      formHeaderTitleCp: headLines[index]?.formHeaderTitle ?? formHeaderTitle,
    };
  }, [formHeaderTitle, headerKey, mainTitle, headLines]);
  useAutoFill();
  useEffect(() => {
    setEntryTime(Date.now());
  }, [activeStep]);
  return (
    <Wrapper>
      <Header mainTitle={mainTitleCp} completedPercentage={completedPercentage} info={info} entryTime={entryTime} />
      <div className="bg-white px-6 py-4 rounded-t-3xl md:rounded-none md:w-1/2 md:flex md:items-center md:justify-center">
        <FormInputs
          formHeaderTitle={formHeaderTitleCp}
          key={activeStep}
          id={id}
          canBeSkipped={canBeSkipped}
          entryTime={entryTime}
          {...rest}
        />
      </div>
    </Wrapper>
  );
};
const Wrapper = ({ className, ...props }: React.HTMLAttributes<HTMLElement>) => (
  <div
    className={cn(
      'pt-6 bg-primary-800 w-full flex flex-col gap-4 md:flex-row md:pt-0 md:bg-white md:h-full',
      className
    )}
    {...props}
  />
);
const useAutoFill = () => {
  const { user } = useAuth();
  const { setValue } = useFormContext();
  const { setWorkerId, setIsFirstStepSuccessful } = useWorkerApplicationCxt();
  useEffect(() => {
    if (user?.email) {
      setIsFirstStepSuccessful(true);
      setWorkerId(user.id);
      setValue('email', user.email);
      setValue('name', user.name);
      setValue('surname', user.surname);
      setValue('phone_number', user.phone_number);
    }
  }, [
    setIsFirstStepSuccessful,
    setValue,
    setWorkerId,
    user?.email,
    user?.id,
    user?.name,
    user?.phone_number,
    user?.surname,
    user?.type,
  ]);
};
